import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { useTranslation } from '@/config/i18n';
import PATH from '@/routes/path';
import PlanForm from '@/pages/plan/components/PlanForm';

const PlanEditPage: React.FC = () => {
  const [t] = useTranslation('');
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  return (
    <>
      <div className="header-top">
        <h2 className="title flex">
          <span
            className="pi pi-arrow-left text-[20px] text-gray-500 cursor-pointer"
            onClick={() => navigate(PATH.plan)}
          ></span>
          <span className="ml-3">{t('plan.edit')}</span>
        </h2>
      </div>
      <PlanForm id={Number(id)} />
    </>
  );
};

export default PlanEditPage;
